import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogAgentSuggestionAuthorAvatarWireframe from './VeltCommentDialogAgentSuggestionAuthorAvatarWireframe/VeltCommentDialogAgentSuggestionAuthorAvatarWireframe';
import VeltCommentDialogAgentSuggestionAuthorNameWireframe from './VeltCommentDialogAgentSuggestionAuthorNameWireframe/VeltCommentDialogAgentSuggestionAuthorNameWireframe';
var VeltCommentDialogAgentSuggestionAuthorWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-author-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAgentSuggestionAuthorWireframe.Avatar = VeltCommentDialogAgentSuggestionAuthorAvatarWireframe;
VeltCommentDialogAgentSuggestionAuthorWireframe.Name = VeltCommentDialogAgentSuggestionAuthorNameWireframe;
export default VeltCommentDialogAgentSuggestionAuthorWireframe;
